import { useState, useEffect } from "react";

import { Button, Label, Table } from "reactstrap";

//Unform e componentes
import ModalViewArquivo from "@/frontend/componentes/ModalViewArquivo";

//Context
import { useAuth } from "@/frontend/context/auth";

//Common
import { fn_getTipoAnexoSolicitacao } from "@/common/siig";

//Util
import { ICONES_SIIG } from "@/frontend/utils/icones";
import { fn_getPathTenant } from "@/frontend/utils/sessao";
import { fn_getPastaUploadSolicitacao } from "@/frontend/utils/file";

//API
import { api_listar, ROTA_LISTAR } from "@/frontend/services/api/api_list";

function TAnexos_list({ solicitacao }) {
  const { sessaoUsuario } = useAuth();

  //### USE STATE ###
  const [modalOpenArquivo, setModalOpenArquivo] = useState(false);

  const [anexos, setAnexos] = useState([]);
  const [anexo, setAnexo] = useState(null);

  useEffect(() => {
    //Se a solicitação já vier com a lista de anexos
    if (solicitacao.anexos) {
      setAnexos(solicitacao.anexos);
    }
    //Senão
    else {
      //Carrega os anexos da solicitação
      async function loadAnexos() {
        setAnexos(
          await api_listar(
            ROTA_LISTAR.SOLICITACAO_ANEXO,
            `id_solicitacao=${solicitacao.id}`,
          ),
        );
      }

      loadAnexos();
    }
  }, []);

  //### EVENTOS ###
  //OnClick - Visualizar anexo
  function handleBotaoVisualizarAnexo(anexo) {
    setAnexo(anexo);
    setModalOpenArquivo(true);
  }

  return (
    <div>
      <Table responsive>
        <thead>
          <tr>
            <td width="15%" className="table-header">
              Tipo
            </td>

            <td width="30%" className="table-header">
              Nome
            </td>

            <td className="table-header">Observação</td>

            <td width="5%" align="center" className="table-header">
              Anexo
            </td>
          </tr>
        </thead>

        <tbody>
          {anexos.map((anexo) => (
            <tr key={anexo.id}>
              <td>{fn_getTipoAnexoSolicitacao(anexo.tipo_anexo)?.label}</td>

              <td>{anexo.nome}</td>

              <td>{anexo.observacao}</td>

              <td align="center">
                <Button
                  size="sm"
                  color="primary"
                  name="btnVisualizarAnexo"
                  title="Visualizar anexo"
                  className="mt-2 btn-icone"
                  onClick={() => handleBotaoVisualizarAnexo(anexo)}
                >
                  {ICONES_SIIG.ANEXOS}
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {modalOpenArquivo && (
        <ModalViewArquivo
          pastaArquivo={fn_getPastaUploadSolicitacao(
            fn_getPathTenant(sessaoUsuario),
            solicitacao.numero,
          )}
          nomeArquivo={anexo.nome_arquivo}
          solicitacao={solicitacao} //título com o tipo e o pagamento do arquivo
          isOpen={modalOpenArquivo}
          toggleModal={() => setModalOpenArquivo(!modalOpenArquivo)}
          flutuante={true}
        />
      )}
    </div>
  );
}

export default TAnexos_list;
